import "./ConfirmDialog.css";

const ConfirmDialog = ({
    open,
    title = "Are you sure?",
    message,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    loading = false,
    onConfirm,
    onCancel,
}) => {
    if (!open) {
        return null;
    }

    return (
        <div className="confirm-dialog-backdrop" role="dialog" aria-modal="true">
            <div className="confirm-dialog-card">
                <div className="confirm-dialog-header">
                    {/* <span className="confirm-dialog-icon">
                        <i className="las la-exclamation-triangle" />
                    </span> */}
                    <div>
                        <h3>{title}</h3>
                        {message && <p>{message}</p>}
                    </div>
                </div>

                <div className="confirm-dialog-actions">
                    <button
                        type="button"
                        className="confirm-dialog-btn cancel"
                        onClick={onCancel}
                        disabled={loading}
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        className="confirm-dialog-btn confirm"
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? "Processing..." : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;

